import { lazy } from 'react';

export const MainLayoutAsync = lazy(() => import('./MainLayout'));
